import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { fusionAuthService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseLinkFusionAuthUserMutationProps = {
	userId: string;
	onSuccess: Function;
};

const useLinkFusionAuthUserMutation = ({
	userId,
	onSuccess,
}: UseLinkFusionAuthUserMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		(data: any) => {
			return fusionAuthService.linkUser({
				userId: userId,
				fusionAuthUserId: data.fusionAuthUserId,
			});
		},
		{
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "SSO ID is successfully linked to RISE user",
					}),
				);
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useLinkFusionAuthUserMutation;
